/* eslint-disable no-void */

import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useDataFetchIndicator } from '..';
import globalpayApi from '../../services/globalpay.config';

type HookProps = {
  api: vp.Api;
  bearer: string | undefined;
};

type ReturnTuple = [
  vp.GlobalPayTokenResponse,
  (_params: vp.GlobalPayTokenRequest) => void,
  (_params: vp.GlobalPayTokenRequest) => Promise<vp.GlobalPayTokenResponse>,
  () => void,
];

function useFetchFinancialInstitutionBranches({ api, bearer }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.GlobalPayTokenRequest>();
  const [response, setResponse] = useState<vp.GlobalPayTokenResponse>({
    Success: false,
    ErrorMessage: '',
    id: '',
    time_created: '',
    status: '',
    usage_mode: '',
    merchant_id: '',
    merchant_name: '',
    account_id: '',
    account_name: '',
    reference: '',
    card: {
      masked_number_last4: '',
      brand: '',
      expiry_month: '',
      expiry_year: '',
    },
    action: {
      id: '',
      type: '',
      time_created: '',
      result_code: '',
      app_id: '',
      app_name: '',
    },
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const { t } = useTranslation('translations', { keyPrefix: 'Common' });
  useEffect(() => {
    const sendRequest = async (requestParams: vp.GlobalPayTokenRequest) => {
      setDataFetchingInfo(true, `${t('Loading')}`, 'fullScreen');
      const res = await api.fetchGlobalPayToken(requestParams, bearer, source);

      setResponse(res);
      setDataFetchingInfo(false);
      setSendRequest(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (_params: vp.GlobalPayTokenRequest) => {
      setParams(_params);
      setSendRequest(true);
    },
    (_params: vp.GlobalPayTokenRequest) => api.fetchGlobalPayToken(_params, bearer, source),
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        id: '',
        time_created: '',
        status: '',
        usage_mode: '',
        merchant_id: '',
        merchant_name: '',
        account_id: '',
        account_name: '',
        reference: '',
        card: {
          masked_number_last4: '',
          brand: '',
          expiry_month: '',
          expiry_year: '',
        },
        action: {
          id: '',
          type: '',
          time_created: '',
          result_code: '',
          app_id: '',
          app_name: '',
        },
      });
      setSendRequest(false);
    },
  ];
}

export default globalpayApi.withApiHook<HookProps, ReturnTuple>(useFetchFinancialInstitutionBranches);
